import {
    createApp
} from 'vue'
import App from './App.vue'

import {
    createWebHistory,
    createRouter
} from 'vue-router'

import MasonryWall from '@yeger/vue-masonry-wall';
import HomeView from './components/views/HomeView';
import ArticleView from './components/views/ArticleView';
import SectionView from './components/views/SectionView';
import PrivacyView from './components/views/PrivacyView';
import PoliticaView from './components/views/PoliticaView';

import 'bootstrap'
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import 'bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js'
import ContainerNode from './components/navigator/ContainerNode.vue';

const routes = [{
        path: "/index.html",
        component: HomeView
    },
    {
        path: "/informativa-privacy",
        component: PrivacyView
    },
    {
        path: "/politica-utilizzo",
        component: PoliticaView
    },
    {
        path: "/section/:section",
        component: SectionView
    },
    {
        path: "/section/:section/:version",
        component: SectionView
    },
    {
        path: "/:article/:version",
        component: ArticleView
    },
    {
        path: "/:article",
        component: ArticleView
    }
]

/**
 * Carica la configurazione dell'applicazione:
 * in caso in cui l'app sia stata lanciata con delle variabili di ambiente
 * se uguali a quelle presenti nella configurazione queste vengono sovrascritte
 */
const response = await fetch('/config.json?v=2');
const config = await response.json();
Object.keys(process.env).forEach(key => {
  if (key.startsWith('VUE_APP_')) {
    config[key] = process.env[key];
    if (process.env.NODE_ENV == "development") {
        console.log(`Configurazione sovrascritta: ${key} = ${process.env[key]}`);
    }
  }
});

const router = createRouter({
    history: createWebHistory(config.VUE_APP_BASE_PATH),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve) => {
            setTimeout(() => {
                if (savedPosition) {
                    resolve(savedPosition);
                } else {
                    resolve({
                        top: 0,
                        left: 0
                    });
                }
            }, 100);
        });
    }
})


router.afterEach(() => {
    const meta = document.createElement("meta");
    meta.httpEquiv = "Cache-Control";
    meta.content = "no-cache, no-store, must-revalidate";
    document.head.appendChild(meta);
});

const app = createApp(App)
app.config.globalProperties.$config = config
app.component('ContainerNode', ContainerNode)
app.use(router)
app.use(config)
app.use(MasonryWall)
app.mount('#app')